import { InputSelectProps } from './input-select.types'
import styles from './input-select.module.scss'
import cl from 'classnames'
import { Input, Select } from '@touche-lts/panel-ui/dist'

const InputSelectComponent = (props: InputSelectProps) => {
  const {
    className,
    style,
    inputProps: { className: classNameInput, ...restInput },
    selectProps: {
      containerClassName,
      className: classNameSelect,
      ...restSelect
    }
  } = props

  return (
    <div className={cl(styles.container, className)} style={style}>
      <Input
        colorPreset='dark'
        className={cl(styles.input, classNameInput)}
        {...restInput}
      />
      <div className={styles.verticalLine} />
      <Select
        colorPreset='dark'
        containerClassName={cl(styles.selectContainer, containerClassName)}
        className={cl(styles.select, classNameSelect)}
        {...restSelect}
      />
    </div>
  )
}

const InputSelect = InputSelectComponent
export { InputSelect }
